export default __webpack_public_path__ + "static/media/EAST2550.34I-34691_-19293_0.d605a88d.jpg";